import * as tslib_1 from "tslib";
import { themr } from '@nextiva/analytics-lib';
import { SearchField, SpinnerSvg, TextField } from '@nextiva/next-ui';
import { isFilled } from "../../../utils/checks";
import cx from 'classnames';
import { debounce, filter, map, some } from 'lodash';
import React from 'react';
import NotFound from '../NotFound';
import Styles from "./SingleSelectable.css";
import SingleOptionComponent from './SingleSelectableOption';

var SingleSelectable =
/** @class */
function (_super) {
  tslib_1.__extends(SingleSelectable, _super);

  function SingleSelectable() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.scrollbar = React.createRef();
    _this.state = {
      options: _this.props.options,
      searchValue: '',
      isTurnArrow: false,
      isVisibleArrow: false
    };
    _this.debounceScrollOptions = debounce(function () {
      var current = _this.scrollbar.current;

      if (!current) {
        return;
      }

      var scrollTop = current.scrollTop,
          offsetHeight = current.offsetHeight,
          firstElementChild = current.firstElementChild;

      if (!firstElementChild) {
        return;
      }

      _this.setState({
        isTurnArrow: scrollTop + offsetHeight === firstElementChild.offsetHeight,
        isVisibleArrow: current.offsetHeight < firstElementChild.offsetHeight
      });
    }, 100);

    _this.onClickScrollOptions = function () {
      var current = _this.scrollbar.current;

      if (!current) {
        return;
      }

      var scrollTop = current.scrollTop,
          offsetHeight = current.offsetHeight;
      var isTurnArrow = _this.state.isTurnArrow;
      current.scroll({
        left: 0,
        behavior: 'smooth',
        top: scrollTop + (40 - (offsetHeight - scrollTop) % 40) * (isTurnArrow ? -1 : 1)
      });
    };

    _this.handleSearch = function (_, searchValue) {
      _this.setState({
        searchValue: searchValue
      }, function () {
        _this.updateOptions(_this.props.options);
      });
    };

    _this.handlerClick = function (option) {
      return function (event) {
        if (event) {
          event.stopPropagation();
        }

        _this.props.handlerClick(option);
      };
    };

    _this.isSelected = function (option) {
      var _a = _this.props,
          selectedOptions = _a.selectedOptions,
          activeCategoryId = _a.activeCategoryId;
      return isFilled(activeCategoryId) && isFilled(option.id) && selectedOptions && selectedOptions[activeCategoryId] && some(selectedOptions[activeCategoryId], {
        id: option.id
      });
    };

    return _this;
  }

  SingleSelectable.prototype.componentDidMount = function () {
    var _a = this.props,
        async = _a.async,
        loadCategories = _a.loadCategories,
        isCategories = _a.isCategories,
        options = _a.options;

    if (async && isCategories && !options.length && loadCategories) {
      loadCategories();
    }

    var scrollbar = this.scrollbar;

    if (scrollbar && scrollbar.current) {
      scrollbar.current.addEventListener('scroll', this.debounceScrollOptions);
      this.debounceScrollOptions();
    }
  };

  SingleSelectable.prototype.componentWillUnmount = function () {
    var scrollbar = this.scrollbar;

    if (scrollbar && scrollbar.current) {
      scrollbar.current.removeEventListener('scroll', this.debounceScrollOptions);
    }
  }; // TODO: need to replace componentWillReceiveProps to static getDerivedStateFromProps


  SingleSelectable.prototype.componentWillReceiveProps = function (nextProps) {
    var options = this.props.options;

    if (options !== nextProps.options) {
      this.updateOptions(nextProps.options);
    }
  };

  SingleSelectable.prototype.updateOptions = function (options) {
    var searchValue = this.state.searchValue;
    this.setState({
      options: filter(options, function (option) {
        return option.name.toLowerCase().includes(searchValue.toLowerCase());
      })
    });
  };

  SingleSelectable.prototype.render = function () {
    var _this = this;

    var _a, _b;

    var _c = this.props,
        async = _c.async,
        title = _c.title,
        editable = _c.editable,
        allowSearch = _c.allowSearch,
        isCategories = _c.isCategories,
        SingleOption = _c.singleOptionComponent,
        handleChangeTitle = _c.handleChangeTitle,
        beforeList = _c.beforeList,
        children = _c.children,
        isError = _c.isError,
        withoutControls = _c.withoutControls,
        activeCategoryId = _c.activeCategoryId,
        theme = _c.theme,
        _d = _c.selectedOptions,
        selectedOptions = _d === void 0 ? {} : _d;
    var _e = this.state,
        options = _e.options,
        searchValue = _e.searchValue,
        isTurnArrow = _e.isTurnArrow,
        isVisibleArrow = _e.isVisibleArrow;
    return React.createElement("div", {
      className: theme.singleSelectable,
      "data-test": "single-selectable"
    }, editable ? React.createElement(TextField, {
      value: title,
      isError: isError,
      className: theme.titleEdit,
      onChange: handleChangeTitle,
      placeholder: "My filter name",
      inputClassName: theme.titleInput
    }) : title && React.createElement("h3", {
      className: theme.title
    }, title), allowSearch && React.createElement(SearchField, {
      className: theme.search,
      value: searchValue,
      onChange: this.handleSearch
    }), beforeList, React.createElement("div", {
      className: cx(theme.wrapper, (_a = {}, _a[theme.withoutControls] = withoutControls, _a)),
      ref: this.scrollbar,
      "data-test": "single-selectable-wrapper"
    }, options.length ? React.createElement("ul", {
      className: theme.options
    }, map(options, function (option, index) {
      var _a;

      return React.createElement(SingleOption, {
        key: index,
        option: option,
        className: cx(theme.option, (_a = {}, _a[theme.active] = activeCategoryId === option.id, _a[theme.selected] = _this.isSelected(option), _a)),
        handlerClick: _this.handlerClick(option),
        quantitySelected: selectedOptions[option.id] ? selectedOptions[option.id].length : undefined
      });
    })) : async ? React.createElement(SpinnerSvg, {
      size: 30,
      thickness: 2,
      style: {
        height: '100%'
      },
      className: theme.optionsLoading
    }) : React.createElement(NotFound, null)), isCategories && isVisibleArrow && React.createElement("div", {
      "data-test": "scroll-arrow",
      onClick: this.onClickScrollOptions,
      className: cx(theme.scrollArrow, (_b = {}, _b[theme.turnScrollArrow] = isTurnArrow, _b))
    }), children);
  };

  SingleSelectable.defaultProps = {
    async: false,
    editable: false,
    allowSearch: false,
    isCategories: false,
    options: [],
    singleOptionComponent: SingleOptionComponent,
    isError: false
  };
  return SingleSelectable;
}(React.PureComponent);

export default themr(SingleSelectable, Styles);